import { createServerFn } from '@tanstack/react-start'
import { z } from 'zod'
import { getFromS3, putToS3 } from '../../lib/s3'
import type { Note } from './noteSchemas'

export const toggleNoteHidden = createServerFn({ method: 'POST' })
  .inputValidator(z.object({ noteId: z.string().min(1) }))
  .handler(async (ctx): Promise<{ hidden: boolean }> => {
    const note: Note = await getFromS3(`notes/${ctx.data.noteId}.json`)
    const newHidden = !note.hidden
    const updated: Note = { ...note, hidden: newHidden }
    await putToS3(`notes/${ctx.data.noteId}.json`, updated)
    return { hidden: newHidden }
  })
